module.exports = __webpack_public_path__ + "img/header.cb09e1cb.png";